import { apiClient } from '@/lib/api/client';

import type { BookingTransfer, TransferResponseWrapper } from '@/features/booking/types/transferTypes';


export const transferService = {
    /**
     * Creates a transfer request for a specific booking.
     * POST /api/booking/v1/booking/:bookingID/transfer
     */
    async createTransfer(bookingId: string): Promise<BookingTransfer> {
        try {
            const response = await apiClient.post<TransferResponseWrapper>(
                `/api/booking/v1/booking/${bookingId}/transfer`
            );
            return response.data?.booking_transfer;
        } catch (error) {
            console.error('Error creating booking transfer:', error);
            throw error;
        }
    },

    /**
     * Fetches details of a specific booking transfer.
     * GET /api/booking/v1/booking/booking-transfer/:bookingTransferID
     */
    async getTransferById(bookingTransferId: string): Promise<BookingTransfer> {
        try {
            const response = await apiClient.get<TransferResponseWrapper>(
                `/api/booking/v1/booking/booking-transfer/${bookingTransferId}`
            );

            return response.data?.booking_transfer;
        } catch (error) {
            console.error('Error fetching booking transfer details:', error);
            throw error;
        }
    },

    /**
     * Cancels a pending booking transfer.
     * PUT /api/booking/v1/booking/:bookingID/transfer/cancel
     */
    async cancelTransfer(bookingId: string): Promise<void> {
        try {
            await apiClient.put(
                `/api/booking/v1/booking/${bookingId}/transfer/cancel`
            );
        } catch (error) {
            console.error('Error canceling booking transfer:', error);
            throw error;
        }
    },

    /**
     * Accepts an incoming booking transfer.
     * POST /api/booking/v1/booking/booking-transfer/:bookingTransferID/accept
     */
    async acceptTransfer(bookingTransferId: string): Promise<void> {
        try {
            await apiClient.post(
                `/api/booking/v1/booking/booking-transfer/${bookingTransferId}/accept`
            );
        } catch (error) {
            console.error('Error accepting booking transfer:', error);
            throw error;
        }
    },

    /**
     * Fetches all transfers for the current user.
     * GET /api/booking/v1/booking/booking-transfer/all
     * TODO: ADD PAGINATION
     */
    async getAllTransfers(): Promise<BookingTransfer[]> {
        try {
            const response = await apiClient.get<{ data: { booking_transfer: BookingTransfer }[] }>(
                '/api/booking/v1/booking/booking-transfer/all'
            );
            return (response.data || []).map(item => item.booking_transfer);
        } catch (error) {
            console.error('Error fetching all transfers:', error);
            throw error;
        }
    }
};